import React from 'react'
import ToDoList from './Component/ToDoList'

function App() {
  return (
    <div>
      <ToDoList />
    </div>
  )
}

export default App